// extracted by mini-css-extract-plugin
module.exports = {"container":"TextInput-module__container__e32Bq","sizer":"TextInput-module__sizer__1l4ED","inner":"TextInput-module__inner__RGrL3"};